import {
  faAngleDoubleUp,
  faAngleUp,
  faBus,
  faCar,
  faStar,
  faTruck,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  TypeServiceLabelTable,
  ViajeTrasladoTipoServicio
} from 'app/viaje/models';

type Props = {
  data: any;
  index: number;
  isMobileOrTablet: boolean;
};

const ServiceType = ({ data, index, isMobileOrTablet }: Props) => {
  const current = data[index];
  let serviceType = current.serviceType as ViajeTrasladoTipoServicio;

  if ('service_type' in current) {
    serviceType = current.service_type;
  }

  const isIconServiceEjecutivo =
    serviceType === ViajeTrasladoTipoServicio.EJECUTIVO ? (
      <div className="flex gap-1 items-center text-inkMuted dark:text-inkMuted-dark">
        <FontAwesomeIcon icon={faAngleUp}/>
        <FontAwesomeIcon size="lg" icon={faCar}/>
      </div>
    ) : null;
  const isIconServiceBuses =
    serviceType === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES ? (
      <div className="flex gap-1 items-center">
        <FontAwesomeIcon size="lg" icon={faBus} className="text-purple-400" />
      </div>
    ) : null;
  const isIconServicePlus =
    serviceType === ViajeTrasladoTipoServicio.UTILITARIO ? (
      <div className="flex gap-1 items-center">
        <FontAwesomeIcon size="1x" icon={faTruck} color="#E1D5F2" />
      </div>
    ) : null;

  const getIconValidated = () => {
    if (serviceType === ViajeTrasladoTipoServicio.VIP) {
      return (
        <div className="flex gap-1 items-center">
          <FontAwesomeIcon size="sm" icon={faAngleDoubleUp} color="#D4AF37" />
          <FontAwesomeIcon size="lg" icon={faCar} color="#D4AF37" />
        </div>
      );
    }

    if (serviceType === ViajeTrasladoTipoServicio.EJECUTIVO) {
      return isIconServiceEjecutivo;
    }

    if (serviceType === ViajeTrasladoTipoServicio.SERVICIOS_GRUPALES) {
      return isIconServiceBuses;
    }

    if (serviceType === ViajeTrasladoTipoServicio.UTILITARIO) {
      return isIconServicePlus;
    }

    return (
      <div className="flex gap-1 items-center">
        <FontAwesomeIcon size="lg" icon={faCar} color="#c1c1c1" />
      </div>
    );
  };

  const getShortCodeFromBusType = function (name: string): string {
    const lower = name.toLowerCase();

    // Si empieza con 'minibús' o 'bus', extrae el número
    if (lower.startsWith('minibús') || lower.startsWith('bus')) {
      const numberMatch = name.match(/\d+/); // busca el primer número
      return numberMatch ? numberMatch[0] : '';
    }

    // Casos específicos
    if (lower.includes('furgón')) return 'F';
    if (lower.includes('van ejecutiva')) return 'VE';
    if (lower.includes('envios') || lower.includes('envios')) return 'E';

    return ''; // fallback si no se reconoce
  };

  const iconService = getIconValidated();

  const travel = data[index];
  const star = data[index].hasPriority;

  return (
    <>
      <div className="w-50 flex justify-between text-sm">
        {isMobileOrTablet ? <p>Servicio</p> : null}
        <div className="flex w-full items-center space-x-4 ">
          {iconService}
          <div className="flex items-center space-x-4">
            <p className="text-xs text-ink dark:text-ink-dark">{TypeServiceLabelTable[`${serviceType}`]}</p>{' '}
              {star && <FontAwesomeIcon icon={faStar} color="orange" />}
           
          </div>
        </div>
      </div>
      {current?.bus_requirement ? (
        <p
          className={
            'm-0 mt-2 font-light w-fit text-purple-400 bg-gray-100 rounded-lg pt-1 pb-1 px-2'
          }
          style={{
            fontSize: '14px',
            lineHeight: '12px'
          }}
        >
          {getShortCodeFromBusType(current?.bus_requirement?.bus_type?.name)}
        </p>
      ) : null}
    </>
  );
};

export default ServiceType;
